import {h, createContext} from "preact";
import Widget from "./components/Widget";

export const Config = createContext();

export const Root = (props) => {
    const {
        systemWideAlerts,
        showAffected,
        hideIfNoAlerts,
        formatAffected
    } = props;
    const config = {
        systemWideAlerts,
        showAffected,
        hideIfNoAlerts,
        formatAffected
    };
    return (
        <Config.Provider value={config}>
            <Widget {...props} />
        </Config.Provider>
    )
}

Root.defaultProps = {
    alertFeeds: [],
    widgetTitle: "",
    routes: [], // Not Implemented
    agencies: [], // Not Implemented
    activeOnly: false, // Not Implemented
    accordions: true, // Not Implemented
    routeCircles: true, // Not Implemented
    systemWideAlerts: true,
    showAffected: true,
    formatAffected: {'all':'route_short_name: route_long_name'},
    hideIfNoAlerts: false
};



// WEBPACK FOOTER //
// ./Store.js